import { z } from 'zod';

export const getTrainingSchema = z.object({
  training_id: z.string().min(1),
});

export type GetTrainingPayload = z.infer<typeof getTrainingSchema>;
